/**
 * File: TextField.js
 * Origin: isotect
 * Description: TextField component for forms.
 *
 * Version: v2.0.0
 * Created: 2025-07-24
 * Last Updated: 2026-01-21
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * TextField component renders a text input field with a label for use in forms.
 *
 * @component
 *
 * @param {Object} props - Component properties
 * @param {string} props.label - Label text displayed above or next to the input field
 *
 * @returns {JSX.Element} A text input field with an associated label
 *
 * @example
 * <TextField label="Username" />
 */
function TextField({ label, text, setText }) {
    const handleChange = (e) => {
        setText(e.target.value);
    };

    return (
        <>
            <div className="text-field">
                <label htmlFor={label} className="text-field__label">
                    {label}
                </label>
                <input
                    type="text"
                    name={label}
                    id={label}
                    size="30"
                    maxLength="100"
                    placeholder={label}
                    onChange={handleChange}
                    required
                    value={text}
                />
            </div>
        </>
    );
}

export default TextField;
